/**
 * RidesLookupsService
 * Reference data for the Rides portal: lookups (+ public settings), campuses, ride events.
 * Route: rides/api/rides
 */
import { BaseService } from '../base/BaseService';
import { unwrapRidesResponse as unwrap } from './unwrapRidesResponse';
/** Rides lookups / campuses / events (JWT). */
export class RidesLookupsService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RidesLookupsService.DEFAULT_SERVICE_PATH,
            basePath: RidesLookupsService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/rides/lookups — every Rides lookup table + countries + active campuses + public settings. */
    async getLookups() {
        return unwrap(await this.getLookupsRaw(), 'Rides lookups not found');
    }
    getLookupsRaw() {
        return this.http.get(this.buildUrl('lookups'));
    }
    /**
     * GET api/rides/public/settings — ANONYMOUS. Public settings + public copy for the pages
     * people see before signing in (landing, sign-in, register, privacy, terms, maintenance).
     */
    async getPublicSettings() {
        return unwrap(await this.getPublicSettingsRaw(), 'Rides settings not found');
    }
    getPublicSettingsRaw() {
        return this.http.get(this.buildUrl('public/settings'));
    }
    /** GET api/rides/campuses — active ride campuses with Sunday service times. */
    async getCampuses() {
        return (await this.getCampusesRaw()).data ?? [];
    }
    getCampusesRaw() {
        return this.http.get(this.buildUrl('campuses'));
    }
    /** GET api/rides/events?from&to — events visible in Rides (yyyy-MM-dd range). */
    async getEvents(query = {}) {
        return (await this.getEventsRaw(query)).data ?? [];
    }
    getEventsRaw(query = {}) {
        return this.http.get(this.buildUrlWithParams('events', { from: query.from, to: query.to }));
    }
}
RidesLookupsService.DEFAULT_SERVICE_PATH = 'rides';
RidesLookupsService.BASE_PATH = 'api/rides';
//# sourceMappingURL=RidesLookupsService.js.map